"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionHeader = void 0;
const react_1 = __importDefault(require("react"));
const forms_1 = require("../../forms");
const popovers_1 = require("../../modals/popovers");
const SectionHeader_styles_1 = require("./SectionHeader.styles");
const SectionHeader = ({ title, informationText, showSwitch, hideItems, setHideItems }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeader_styles_1.TitleRowWrapper, null,
            react_1.default.createElement(SectionHeader_styles_1.TitleWrapper, null,
                react_1.default.createElement(SectionHeader_styles_1.Title, null, title),
                informationText && react_1.default.createElement(popovers_1.Tooltip, { message: informationText })),
            showSwitch && react_1.default.createElement(forms_1.Switch, { active: !hideItems, onChange: setHideItems, isLarge: true })),
        react_1.default.createElement(SectionHeader_styles_1.SectionLine, null)));
};
exports.SectionHeader = SectionHeader;
//# sourceMappingURL=SectionHeader.js.map